/*jslint node:false*/
/*jslint browser: true, devel:true*/
/*global $, define, module, test, ok*/

import $ from 'jquery';
import spinner from './../spinner.js';
import { setRecentlyPlayedGame } from './mygames.js';
import notifications from './../notifications.js';
import providerLoader from './providers/provider-loader.js';

const $window = $(window);

function load(result) {
	const $ingame = $('.ingame');
	const $game = $ingame.find('.game');

	const $flashGame = $('<iframe>', {
		id: 'iframe-game',
		src: result.data.URL,
		scrolling: 'no'
	});

	if (result.gameLoadType === 'REDIRECTION') {
		window.location.replace(result.data.URL);
	} else if (result.gameLoadType === 'JSON') {
		providerLoader.load(result.data.JSON);
	} else {
		$('.container').addClass('u-hide');
		$ingame.addClass('u-show');
		$game.empty();

		$flashGame.css({
			width: $window.width(),
			height: $window.height()
		});
		$flashGame.appendTo($game);

		$('body').bind('orientationchange', (event) => {
			if (event.orientation === 'portrait') {
				$flashGame.css('width', $window.width());
			} else if (event.orientation === 'landscape') {
				$flashGame.css('height', $window.height());
				$flashGame.css('width', $window.width());
			}
		});
	}
}
/**
 * Do an ajax call to the game-loader-service and process response to load game
 * @param $game, game object to extract data from
 * @param funMode, boolean false by default
 * @param invalidSessionErrorCallback, callback to execute when session no longer valid
 */
function loadGame(gameCode, mode = 'REAL', invalidSessionErrorCallback) {
	const w = window.innerWidth;
	const h = window.innerHeight;

	const jqxhr = $.ajax({
		url: `/load/${encodeURIComponent(gameCode)}/${mode.toUpperCase()}/${w}/${h}`,
		type: 'GET'
	});
	const escapedGameCode = gameCode.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, "\\\\$&");
	const $game = $(`[data-game="${escapedGameCode}"]`).parent();
	spinner.show($game);

	jqxhr.done((response) => {
		if (response.status === 'SUCCESS') {
			setRecentlyPlayedGame(escapedGameCode).then(() => {
				load(response.result);
			});
		} else if (response.errorCode === '00003') {
			//session not valid
			if (invalidSessionErrorCallback) {
				invalidSessionErrorCallback();
			}
		} else {
			console.error(`Game loader Error: ${response.errorDescription}, code: ${response.errorCode}`);
			notifications.showNotification(response.errorDescription, 'red', true);
		}
	}).fail(() => {
		console.error('Error calling game loader service');
		notifications.showNotification(response.errorDescription, 'red', true);
	}).always(() => {
		spinner.hide($game);
	});
}

export default {
	loadGame
};



// WEBPACK FOOTER //
// ./mobile-core/src/casino/ingame.js